import { useEffect, useReducer, useState, useMemo } from 'react' // Add useMemo import

import { AuthDispatchContext, AuthStateContext } from '../authContext/AuthContext'
import { SET_AUTHORISED, SET_UNAUTHORISED, authReducer, initialState, initializer } from '../authReducer/authReducer'

import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { CurrencyInfo } from '@percent/partner-dashboard/services/donation/donationService'
import { AuthContextControllerProps } from './AuthContextController.types'

export function AuthContextController({ children }: AuthContextControllerProps) {
  const [state, dispatch] = useReducer(authReducer, initialState, initializer)
  const [currencyInfoState, setCurrencyInfoState] = useState<CurrencyInfo[] | undefined>(undefined)

  const { authService, accountService, donationService } = useServices()

  const authStateValue = useMemo(
    () => ({
      ...state,
      currencyInfo: currencyInfoState
    }),
    [state, currencyInfoState]
  )

  useEffect(() => {
    const getUserData = async () => {
      try {
        const {
          data: { data }
        } = await accountService.getAccount()
        let partner = {}

        if (data?.partnerId) {
          const { data: partnerData } = await authService.getPartner()
          partner = partnerData.data
        }

        const {
          data: { data: currencyInfoData }
        } = await donationService.getCurrencyInfo()
        setCurrencyInfoState(currencyInfoData)

        dispatch({
          type: SET_AUTHORISED,
          payload: {
            user: data,
            partner
          }
        })
      } catch (err) {
        dispatch({
          type: SET_UNAUTHORISED
        })
      }
    }

    if (state.isAuthorised && !state.isAuthorising) {
      getUserData()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, state.isAuthorised, state.isAuthorising, authService, accountService])

  return (
    <AuthStateContext.Provider value={authStateValue}>
      {' '}
      <AuthDispatchContext.Provider value={dispatch}>{children}</AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  )
}
